import { render, staticRenderFns } from "./pjBiddingNotice.vue?vue&type=template&id=503f5856&scoped=true"
import script from "./pjBiddingNotice.vue?vue&type=script&lang=js"
export * from "./pjBiddingNotice.vue?vue&type=script&lang=js"
import style0 from "./pjBiddingNotice.vue?vue&type=style&index=0&id=503f5856&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "503f5856",
  null
  
)

export default component.exports